<template>
  <v-select
    :label="docs.name"
    :value="value"
    :items="docs.enumValues"
    item-text="label"
    item-value="id"
    :disabled="readonly"
    multiple
    chips
    small-chips
    deletable-chips
    @change="$emit('input', $event)"
  ></v-select>
</template>

<script lang="js">
export default {
  name: 'SetNavigationTabType',
  props: {
    value: {
      type: Array,
      required: true,
    },
    docs: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
